module.exports = __webpack_public_path__ + "media/alarm.909729e7.wav";